import React from "react";
import styled from "@emotion/styled";
import { row } from "@ui/style/layout";
import { useExercisePage } from "@ui/pages/exercise/hooks/use-exercise-page";
import { SelectedExerciseCard } from "@ui/pages/exercise/components/selected-exercise-card";
import { HorizontalEdgeBlur } from "@ui/pages/exercise/components/horizontal-edge-blur";

interface SelectedExerciseListingPanelProps {
	className?: string;
}

export const SelectedExerciseListingPanel: React.FC<SelectedExerciseListingPanelProps> = ({ className }) => {
	const { selectedExercises } = useExercisePage();

	return (
		<HorizontalEdgeBlur blurWidth={50} className={className}>
			<Row>
				{selectedExercises.map(exercise => (
					<SelectedExerciseCard key={exercise.id} exercise={exercise} />
				))}
			</Row>
		</HorizontalEdgeBlur>
	);
};

const Row = styled.div`
	${row("SM")}
`;
